import React from 'react';
import { VStack, Text } from '@skin-seoul/design-system';
import { LucideIcon } from '../LucideIcon';

export const OrderCardError = () => {
  return (
    <VStack
      width="100%"
      bg="generic.0"
      border="1px solid"
      borderColor="neutral.100"
      borderRadius="8px"
      padding={6}
      gap={3}
      alignItems="center"
      justifyContent="center"
      minHeight="200px"
    >
      <VStack gap={2} alignItems="center">
        <LucideIcon name="PackageSearch" width={12} height={12} color="neutral.400" />
        <Text textStyle="label.medium" fontWeight="medium" color="neutral.700" textAlign="center">
          Order Not Found
        </Text>
        <Text textStyle="paragraph.small" fontWeight="regular" color="neutral.400" textAlign="center" maxWidth="300px">
          We couldn&apos;t find any order with this Order ID. Please verify your Order ID and try again.
        </Text>
      </VStack>
    </VStack>
  );
};

